import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ kind = "privacy" }) {
  const isCookie = kind === "cookie";
  return (
    <div className="min-h-screen bg-[#0C0C0C] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-[#FFC20E] font-display font-bold uppercase mb-8">
          <ArrowLeft size={18} /> Torna al morso
        </Link>
        <h1 className="font-display font-black uppercase text-5xl sm:text-6xl text-[#FFC20E]">
          {isCookie ? "Cookie Policy" : "Privacy Policy"}
        </h1>
        <div className="mt-6 space-y-4 text-white/75 leading-relaxed">
          {isCookie ? (
            <>
              <p>UNGRIP utilizza cookie tecnici necessari al funzionamento del sito e, previo consenso, cookie di misurazione e marketing (GA4, Google Tag Manager, Meta Pixel).</p>
              <p>Puoi gestire le tue preferenze in qualsiasi momento tramite il banner cookie. I cookie di marketing vengono attivati solo dopo il tuo consenso esplicito.</p>
              <p>Categorie: cookie tecnici (sempre attivi), cookie analitici, cookie di marketing/profilazione.</p>
              <p>Per esercitare i tuoi diritti scrivi a ciao@ungrip.it.</p>
            </>
          ) : (
            <>
              <p>UNGRIP tratta i tuoi dati personali (email e dati di iscrizione all'UNGRIP Club) nel rispetto del Regolamento UE 2016/679 (GDPR).</p>
              <p>Finalità: invio di offerte riservate, drop, limited edition e comunicazioni del Club, solo previo tuo consenso marketing esplicito.</p>
              <p>Base giuridica: consenso (art. 6.1.a GDPR). Registriamo email, data di iscrizione, timestamp e versione del consenso.</p>
              <p>Diritti: puoi richiedere accesso, rettifica, cancellazione (diritto all'oblio), limitazione e revoca del consenso in qualsiasi momento scrivendo a ciao@ungrip.it. Ogni comunicazione include un link di disiscrizione.</p>
              <p>I dati non vengono ceduti a terzi non autorizzati e sono conservati per il tempo strettamente necessario.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
